import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, Box, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import icon from '../../Assets/danger.svg'

const AlertDialog = ({ dialogContentText, open, onClose, onAction, }) => {
    return (
        <Dialog open={open} maxWidth={"xs"} onClose={onClose} >
            <Box sx={{ padding: 4, position: "relative" }}>
                <div onClick={onClose} className='absolute bg-black rounded-full h-5 w-5 top-4 right-4 z-99 flex items-center justify-center bg-opacity-80 cursor-pointer'>
                    <CloseIcon sx={{ color: "white", fontSize: 16 }} />
                </div>
                <div className='h-24 w-24 mx-auto bg-[#F4B315] rounded-full bg-opacity-25 flex items-center justify-center'>
                    <img src={icon} />
                </div>
                <DialogTitle sx={{ fontSize: 24, fontWeight: 600, textAlign: "center" }}>Do you really want to delete this?</DialogTitle>
                <DialogContent sx={{ paddingY: 0 }}>
                    <DialogContentText sx={{ fontSize: 14 }}>{dialogContentText}</DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                    <Button
                        variant='outlined'
                        sx={{ width: 200, height: 45, color: "gray", borderColor: "rgba(0, 0, 0, .1)" }}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => { onClose(); onAction() }}
                        autoFocus
                        variant="contained"
                        sx={{ color: "white", width: 200, height: 45 }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};


export default AlertDialog